// extracted by mini-css-extract-plugin
export var bold = "_yy-0";